<template>
  <div class="language-switch" @click="changeLang()">
    <span class="current-lang">
      {{ $i18n.locale }}
    </span>
  </div>
</template>

<script>
import { langAvailables } from '../i18n'

export default {
  methods: {
    changeLang: function () {
      // Find current language and set the next available one
      const curLang = this.$i18n.locale
      let index = langAvailables.indexOf(curLang)
      index = (index < langAvailables.length - 1) ? index + 1 : 0

      // this.$i18n.locale = langAvailables[index]
      const route = Object.assign({}, this.$route)
      route.params.lang = langAvailables[index]

      this.$router.push(route)
    }
  }
}
</script>



<style lang="scss">
@import '../assets/styles/_variables.scss';

.language-switch {
  color: $primary;
  cursor: pointer;
  margin-left: 1em;
}

.current-lang {
  text-transform: uppercase;
  color: $purple;
  border: 1px solid $purple-bis;
  padding: 0.3em 0.6em;
  font-size: $size-7;
}
</style>



// WEBPACK FOOTER //
// LanguageSwitch.vue?881d702a